export default __webpack_public_path__ + "static/simple-bar-3cd278b4f55b632c3e30c236074f8c55.png";